import { memo, useState } from 'react'
import { useDispatch } from 'react-redux';
import { handleModal } from '../../redux/actions/modals';
import { ORDER_ENTRY_GRID_REF } from '../../utils/global_functions';
import { ORDER_TYPES } from '../../utils/global_variables';
import { OrderEntry, } from './index'

const ModifyOrdersModal = ({ activeTab, setActiveContent }) => {
    const dispatch = useDispatch()

    const [activeButtonToggleIndex, setActiveButtonToggleIndex] = useState(0)
    const [activeTabKey, setActiveTabKey] = useState(ORDER_TYPES.BASKET);
    const onHide = () => {
        dispatch(handleModal([{ 'MODIFY_ORDER_MODAL': false }]))
    }

    return (
        <OrderEntry orderEntryTab={activeTab} setOrderEntryTab={setActiveContent} activeTabKey={activeTabKey} setActiveTabKey={setActiveTabKey} activeButtonToggleIndex={activeButtonToggleIndex} setActiveButtonToggleIndex={setActiveButtonToggleIndex} onHideModifyModal={onHide} modifyModal={'MODIFY_ORDER_MODAL'} isEdit={true} ref={ORDER_ENTRY_GRID_REF} />
    )
}
export default memo(ModifyOrdersModal)
